import React, { useEffect, useState } from 'react';
import { Loader2, PlayCircle, ShieldCheck } from 'lucide-react';
import { Button } from '../ui/button';
import api from '../../utils/api';
import { toast } from 'sonner';

const fmtDT = (value) => value ? new Date(value).toLocaleString('it-IT') : '-';

export const PromoOperationsAuditPanel = ({ onApplied }) => {
  const [runs, setRuns] = useState([]);
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState('');
  const load = () => api.get('/promotions/operations/runs').then(response => setRuns(response.data.runs || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const run = async (mode) => {
    if (mode === 'apply' && !window.confirm('Creare le attività mancanti per tutte le promozioni confermate e inviare il riepilogo operativo?')) return;
    setBusy(mode);
    try {
      const response = await api.post('/promotions/operations/run', { mode });
      setResult(response.data);
      toast.success(mode === 'dry_run' ? 'Dry-run completato e report inviato' : 'Allineamento applicato e report inviato');
      load(); onApplied();
    } catch (error) { toast.error(error.response?.data?.detail || 'Controllo non riuscito'); }
    finally { setBusy(''); }
  };

  return <section className="rounded-lg border border-slate-200 bg-slate-50 p-4" data-testid="script-panel-card">
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div><h3 className="flex items-center gap-2 font-semibold text-slate-900"><ShieldCheck className="h-4 w-4 text-blue-700" /> Allineamento promozioni attive</h3>
        <p className="mt-1 max-w-2xl text-xs text-slate-500">Il dry-run non crea attività, ma invia il report a Customer Service e Prenotazioni. Apply crea solo le attività mancanti.</p></div>
      <div className="flex gap-2">
        <Button variant="outline" onClick={() => run('dry_run')} disabled={!!busy} data-testid="script-dryrun-btn">{busy === 'dry_run' ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <PlayCircle className="mr-1 h-4 w-4" />} Dry-run + email</Button>
        <Button onClick={() => run('apply')} disabled={!!busy} data-testid="script-apply-btn">{busy === 'apply' ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <ShieldCheck className="mr-1 h-4 w-4" />} Apply</Button>
      </div>
    </div>
    {result && <div className="mt-4 grid gap-2 rounded-lg border border-blue-200 bg-white p-3 sm:grid-cols-5" data-testid="script-run-summary-box">
      <div data-testid="script-stat-total-promos"><p className="text-xs text-slate-500">Promozioni</p><b>{result.promotions_scanned}</b></div>
      <div data-testid="script-stat-conflicts"><p className="text-xs text-slate-500">Conflitti</p><b>{result.conflicts_count}</b></div>
      <div data-testid="script-stat-platforms"><p className="text-xs text-slate-500">Piattaforme</p><b>{result.platforms?.length || 0}</b></div>
      <div data-testid="script-stat-created"><p className="text-xs text-slate-500">Create</p><b>{result.tasks_created}</b></div>
      <div data-testid="script-email-status"><p className="text-xs text-slate-500">Email</p><b className={result.email?.sent ? 'text-emerald-700' : 'text-rose-700'}>{result.email?.status}</b></div>
    </div>}
    {!!runs.length && <div className="mt-4 text-xs" data-testid="script-audit-log-table">
      <div className="hidden grid-cols-[1.2fr_.7fr_1.5fr_.5fr_.9fr_.7fr] gap-2 px-2 pb-2 font-semibold text-slate-500 sm:grid">
        <span>Data</span><span>Modalità</span><span>Operatore</span><span>Promo</span><span>Create / saltate</span><span>Email</span>
      </div>
      {runs.slice(0, 8).map(runItem => <div key={runItem.id} className="grid min-w-0 grid-cols-2 gap-x-3 gap-y-2 border-t border-slate-200 px-2 py-3 sm:grid-cols-[1.2fr_.7fr_1.5fr_.5fr_.9fr_.7fr]"
        data-testid={`script-run-${runItem.id}`}>
        <span><i className="block not-italic text-slate-400 sm:hidden">Data</i>{fmtDT(runItem.started_at)}</span>
        <span><i className="block not-italic text-slate-400 sm:hidden">Modalità</i>{runItem.mode}</span>
        <span className="min-w-0 break-all"><i className="block not-italic text-slate-400 sm:hidden">Operatore</i>{runItem.operator}</span>
        <span><i className="block not-italic text-slate-400 sm:hidden">Promo</i>{runItem.promotions_scanned ?? '-'}</span>
        <span><i className="block not-italic text-slate-400 sm:hidden">Create / saltate</i>{runItem.tasks_created ?? 0} / {runItem.tasks_skipped ?? 0}</span>
        <span className="min-w-0 break-words"><i className="block not-italic text-slate-400 sm:hidden">Email</i>{runItem.email?.status || runItem.status}</span>
      </div>)}
    </div>}
  </section>;
};
